/** @jsxImportSource preact */
import type { JSX } from 'preact'

// The other screens' loading panel, with how long ops should expect to wait for the airline check.
export function QuoteLoadingPanel(): JSX.Element {
  return (
    <div className="mt-2 p-4 bg-gray-50 rounded-md flex justify-center items-center">
      <svg
        className="animate-spin h-6 w-6 text-indigo-600 mr-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <span>Checking the tickets with the airline. This can take a minute or two.</span>
    </div>
  )
}
